// Generated by CoffeeScript 2.7.0
var Integer;

import Base from './base.js';

export default Integer = class Integer extends Base {
  getDisappearedFieldIdsOnInit() {
    return _.pluck(this.logic_rule, 'field_ids');
  }

};
